<div class="navbar-top-search-container" (mouseleave)="searchActive = false">
  <div class="navbar-top-search-border">
    <div class="navbar-top-search-box">
      <!-- Meter/CUPS filter -->
      <div class="navbar-top-search-filter">
        <i class="fas fa-search navbar-top-search-icon"></i>
        <input
          #searchFilter
          class="navbar-top-search-input"
          [ngClass]="{ disabled: loading }"
          type="text"
          id="searchFilter"
          name="searchFilter"
          autocomplete="off"
          (focus)="searchActive = true; setSearchDropdownHeight()"
          (click)="searchActive = true"
          (keyup)="searchActive = true; dropdownFilter($event.target.value, 'search', cupsSelected)"
          (keyup.enter)="checkDeviceToGo($event.target.value)"
          placeholder="{{ searchOptionSelected }}..."
        />
        @if (!searchActive) {
          <i
            class="fas fa-caret-down navbar-top-search-caret"
            (click)="setSearchDropdownHeight(); searchActive = true"
          ></i>
        }
        @if (searchActive) {
          <i class="fas fa-caret-up navbar-top-search-caret" (click)="searchActive = false"></i>
        }
      </div>
      <!-- Search options -->
      @if (currentCupsName) {
        <div class="navbar-top-search-options">
          <!-- Device -->
          <input
            #searchDeviceOption
            class="pointer"
            type="radio"
            id="searchDeviceOption"
            name="searchOptions"
            [value]="false"
            [(ngModel)]="cupsSelected"
            (change)="resetSearchBox(type)"
          />
          <label class="pointer" for="searchDeviceOption" (click)="searchDeviceOption.click()">
            {{ "device" | translate }}
          </label>
          <!-- CUPS -->
          <input
            #searchCupsOption
            class="pointer"
            type="radio"
            id="searchCupsOption"
            name="searchOptions"
            [value]="true"
            [(ngModel)]="cupsSelected"
            (change)="resetSearchBox(type)"
          />
          <label class="pointer" for="searchCupsOption" (click)="searchCupsOption.click()">
            {{ currentCupsName }}
          </label>
        </div>
      }
      <div #searchDropdown class="navbar-top-search-dropdown">
        <!-- Meter selector -->
        @if (!cupsSelected && searchActive && _meterList?.length > 0 && !deviceMatches) {
          <div #metersListContainer class="navbar-top-search-select">
            <cdk-virtual-scroll-viewport
              #metersScroll
              itemSize="10"
              class="navbar-top-virtual-scroller"
            >
              <div
                *cdkVirtualFor="let meter of _meterList"
                (click)="goToSelection(cupsSelected, meter); resetSearchBox(type)"
              >
                <p class="navbar-top-search-option">{{ meter.descripcion }}</p>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        }
        <!-- CUPS selector -->
        @if (cupsSelected && searchActive && _cupsList?.length > 0 && !cupsMatches) {
          <div #cupsListContainer class="navbar-top-search-select">
            <cdk-virtual-scroll-viewport
              #cupsScroll
              itemSize="10"
              class="navbar-top-virtual-scroller"
            >
              <div
                *cdkVirtualFor="let cups of _cupsList"
                (click)="goToSelection(cupsSelected, cups); resetSearchBox(type)"
              >
                <p class="navbar-top-search-option">{{ cups.descripcion }}</p>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        }
      </div>
      @if (deviceMatches?.length > 1 || cupsMatches?.length > 1) {
        <div class="navbar-top-search-matches">
          @if (cupsMatches?.length > 1) {
            @for (cups of cupsMatches; track cups.id) {
              <p class="navbar-top-search-match" (click)="goToCups(cups)">
                {{ cups.clave }}
                <span class="navbar-top-search-match-description">
                  {{ cups.entityDesc }}
                  <i class="fas fa-sitemap"></i>
                </span>
              </p>
            }
          }
          @if (deviceMatches?.length > 1) {
            @for (device of deviceMatches; track device.id) {
              <p class="navbar-top-search-match" (click)="goToDevice(device)">
                {{ device.nroSerie }}
                <span class="navbar-top-search-match-description">
                  @if (device.agrupation) {
                    <i class="fas fa-map"></i>
                    {{ device.agrupation }}
                  } @else if (device.entity) {
                    {{ device.entity }}
                    <i class="fas fa-sitemap"></i>
                  } @else {
                    {{ device.client }}
                    <i class="fas fa-user-tie"></i>
                  }
                </span>
              </p>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
